import Table from "../components/merchant-types/Table";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/* 
加盟店種別一覧
 */
const MerchantTypes = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.MASTER_EDIT);
  return (
    <SpaceBetween size="l">
      <Table />
    </SpaceBetween>
  );
};

export default MerchantTypes;
